import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Axios from "axios";
import { isBrowser } from "react-device-detect";

//STYLES
import * as PrintingProgressStyles from "../../styles/yourOrders/printingProgress";

//COMPONENTS
import PrintProgressItem from "./printingProgressItem";

function PrintingProgress() {
    const params = useParams();
    const [items, setItems] = useState([]);

    useEffect(() => {
        loadPrintingProgress();
    }, []);

    function loadPrintingProgress() {
        const data = { orderID: params.id, fetchType: "cus" };
        Axios.post("/pods/3dPrintingShop/orders/getOrderPrintingProgress", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    for (const item of data.items) {
                        const precentage = Math.floor((100 / parseInt(item.mainItem.totalModels)) * parseInt(item.mainItem.totalBuilt));
                        item.mainItem.progress = precentage;

                        if (item.mainItem.quantity > 1) {
                            for (const eItem of item.extraItems) {
                                const precentage = Math.floor((100 / parseInt(eItem.totalModels)) * parseInt(eItem.totalBuilt));
                                eItem.progress = precentage;
                            }
                        }
                    }
                    setItems(data.items);
                }
            })
            .catch((err) => console.log(err));
    }

    const browserDisplay = (
        <div style={PrintingProgressStyles.body}>
            <Row>
                <Col sm={1}></Col>
                <Col>
                    <div style={PrintingProgressStyles.headerCenter}>
                        <h1>Order Printing Progress</h1>
                    </div>
                    <br />
                    {items.map((item, index) => {
                        return <PrintProgressItem key={index} mainItem={item.mainItem} extraItems={item.extraItems} reload={loadPrintingProgress} />;
                    })}
                </Col>
                <Col sm={1}></Col>
            </Row>
        </div>
    );

    const mobileDisplay = (
        <div style={PrintingProgressStyles.mobile_body}>
            <div style={PrintingProgressStyles.headerCenter}>
                <h1>Order Printing Progress</h1>
            </div>
            <br />
            {items.map((item, index) => {
                return <PrintProgressItem key={index} mainItem={item.mainItem} extraItems={item.extraItems} reload={loadPrintingProgress} />;
            })}
        </div>
    );

    return <div>{isBrowser ? browserDisplay : mobileDisplay}</div>;
}

export default PrintingProgress;
